import { render, staticRenderFns } from "./tpls.vue?vue&type=template&id=7a6f40aa&scoped=true&"
import script from "./tpls.vue?vue&type=script&lang=js&"
export * from "./tpls.vue?vue&type=script&lang=js&"
import style0 from "./tpls.vue?vue&type=style&index=0&id=7a6f40aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f40aa",
  null
  
)

export default component.exports